









import { Component, Prop, Vue } from 'vue-property-decorator';
import { ServerStoreState } from '../types';

@Component
export default class ServerTooltip extends Vue {
  @Prop() private server!: ServerStoreState;
  @Prop(Number) private index!: number;
}
